<template>
    <div class="class-list p-b-64 page">
        <div v-if="indicatorType" style="height: 80vh; display: flex; flex-direction: row; align-items: center">
            <indicatorEmpty :type="indicatorType" :message="indicatorMessage"></indicatorEmpty>
        </div>
        <div v-else>
            <div style="padding-bottom: 70px">
                <div v-if="dialogShow"
                     style="font-size: 14px; color: #ff9e00; padding: 15px 15px; background-color: #fafafa">
                    管理员未设置驳回路线，驳回后将终止流程
                </div>
                <div v-for="(cmpt, i) in itemsList" :key="i"
                     style="font-size: 15px; text-align: left;margin-bottom: 5px">
                    <createCompnents :cmpt="cmpt" :key="cmpt.componentName+'-'+i"
                                     :extra="{ parentIndex: i}"
                                     v-on:onAutoComplete="onAutoComplete(arguments, itemsList)"></createCompnents>
                </div>

                <van-cell
                    v-if="showRefuseSelect"
                    title="驳回到"
                    required="true"
                    arrow-direction="down"
                    @click.native="showPicker()"
                    is-link>
                    <template slot>
                        <div v-if="refuseTarget.label">{{refuseTarget.label}}</div>
                        <div v-else style="color: #a4afbc">请选择</div>
                    </template>
                </van-cell>
                <div style="height: 5px"></div>
                <van-cell
                    title="审批意见"
                    :required="opinionRequired"></van-cell>
                <van-field
                    v-model="opinionRemind"
                    maxlength="2000"
                    placeholder="请输入审批意见"
                    type="textarea"/>
                <div style="font-size: 13px; color: #07affa; text-align: left;margin-top: 10px; margin-left: 15px"
                     @click="showCommonClick">使用常用语
                </div>
            </div>

            <div class="m-l-12 m-r-12" style="position: fixed; bottom: 12px; left: 0px; right: 0px; ">
                <van-button
                    style="background-color: #3388ff; color: white; width: 100%" @click.native="commit(false)">确定
                </van-button>
            </div>
            <van-dialog
                v-model="forceDialog"
                title="提示"
                message="当前表单内容不支持走向后续节点，点击确定将完结流程"
                show-cancel-button
                :before-close="beforeClose"
            >
            </van-dialog>
            <van-popup
                v-model="commonDialog"
            >
                <div style="width: 80vw; font-size: 15px; padding: 10px 0px">
                    <div v-if="commonLoading" style="padding-top: 10px;display: flex">
                        <van-loading type="spinner" style="margin-left: 15px"/>
                    </div>
                    <div v-else>
                        <div v-if="commonList && commonList.length"
                             style="max-height: 70vh; overflow-y: scroll; text-align: left">
                            <div v-for="(common, index) in commonList" :key="index"
                                 style="padding: 10px 0px;position: relative"
                                 @click="opinionRemind+=common.content; commonDialog = false">
                                <div style="padding: 0px 40px 0 25px">{{common.content}}</div>
                                <span v-if="commonDelete" style="position: absolute; right: 10px;top: 10px"
                                      @click.stop="deleteCommonRequest(common.id, index)">
                                <img style="width: 15px; height: 15px" src="../../assets/img/create/删除.png"/>
                            </span>
                            </div>
                        </div>
                        <div v-else style="font-size: 18px; color: #a4afbc;padding-top: 10px">还没有设置任何常用语</div>
                    </div>
                    <div style="text-align: left; padding: 10px 10px">
                        <span v-if="!commonDelete"
                              style="font-size: 13px; color: #07affa; text-align: left;margin-top: 10px; margin-left: 15px"
                              @click="commonAddDialog=true; commonDialog=false">添加</span>
                        <span v-if="!commonDelete && commonList &&commonList.length"
                              style="font-size: 13px; color: #fc5c5d; text-align: left;margin-top: 10px; margin-left: 15px"
                              @click="commonDelete = true">删除</span>
                        <span v-if="commonDelete"
                              style="font-size: 13px; color: #596c83; text-align: left;margin-top: 10px; margin-left: 15px"
                              @click="commonDelete = false">取消</span>
                    </div>
                </div>
            </van-popup>
            <van-popup
                v-model="commonAddDialog"
            >
                <div style="width: 80vw; font-size: 15px; padding: 10px 0px">
                    <van-field
                        v-model="addCommonStr"
                        placeholder="请输入要添加的常用语">
                        <template slot="right-icon">
                            <van-button size="small" type="primary" :disabled="!addCommonStr"
                                        @click="addCommonClick">添加
                            </van-button>
                        </template>
                    </van-field>
                </div>
            </van-popup>
        </div>
    </div>
</template>

<script>
    import head from '../../mixins/head';
    import indicatorEmpty from '../approve/empty';
    import createCompnents from '../approve/createCompnents';
    import componnetInitValue from '../../mixins/component';
    import componentHybird from '../../mixins/component-hybird';
    import { Dialog } from 'vant';

    export default {
        components: {
            createCompnents,
            indicatorEmpty
        },
        name: 'flow-commit',
        mixins: [head, componnetInitValue, componentHybird],
        data() {
            return {
                indicatorType: 0,
                opinionRemind: '',
                opinionRequired: false,
                data: {},
                result: {},
                edges: [],
                nodes: [],
                showRefuseSelect: false,
                refuseTarget: {},
                refuseList: [],
                pick: '',
                dialogShow: false,
                forceDialog: false,
                commonDialog: false,
                commonAddDialog: false,
                commonDelete: false,
                addCommonStr: '',
                commonList: [],
                commonLoading: false,
                commonLoaded: false
            };
        },
        props: {},
        watch: {
            'commonDialog': function () {
                if (!this.commonDialog) {
                    this.commonDelete = false;
                }
            }
        },
        computed: {},
        created() {
            window.moreButton({});
            this.init();
        },
        mounted() {
        },
        methods: {

            init() {
                if (window.saveInstance[window.getCurrentPath()]) {
                    window.restoreSaveInstance(window.getCurrentPath(), this.$data);
                    if (!_.isEmpty(window.tempRelate) && !_.isEmpty(window.tempRelate.data)) {
                        let tempRelate = _.cloneDeep(window.tempRelate.data);
                        let extra = _.cloneDeep(window.tempRelate.extra);
                        window.tempRelate = {};
                        this.returnValue(JSON.stringify(tempRelate), JSON.stringify(extra));
                    }
                } else {
                    if (window.tempData) {
                        // let tempForm = JSON.parse(window.tempForm.temp.form);
                        this.result = window.tempData.result;
                        this.data = window.tempData.data;
                        let process = JSON.parse(this.data.temp.process);
                        this.edges = process.edges;
                        this.nodes = process.nodes;
                        if (this.$route.query.isAgree) {
                            this.opinionRemind = window.tempData.data.temp.opinionRemind;
                        }
                        this.opinionRequired = window.tempData.data.temp.opinionRequired;

                        if (window.tempData.form) {
                            this.initRelate(window.tempData.form, window.tempData.result);
                            this.initFormValue(this.itemsList, _.cloneDeep(window.tempData.form), window.tempData.result);
                        }
                        console.log('itemsList', this.itemsList);
                        if (!this.$route.query.isAgree) {
                            if (this.data.refuseList && this.data.refuseList.length > 0) {
                                for (let i = 0; i < this.data.refuseList.length; i++) {
                                    let refuseItem = this.data.refuseList[i];
                                    for (let j = 0; j < this.nodes.length; j++) {
                                        let node = this.nodes[j];
                                        if (refuseItem.companyApproveWorkflowGroup.nodeId == node.id) {
                                            this.refuseList.push({
                                                text: node.label,
                                                value: {
                                                    nodeSort: refuseItem.targetNodeSort,
                                                    nodeId: refuseItem.companyApproveWorkflowGroup.nodeId
                                                }
                                            });
                                            break;
                                        }
                                    }
                                }
                                if (this.refuseList.length > 1) {
                                    this.refuseTarget = {};
                                    this.showRefuseSelect = true;
                                } else {
                                    this.refuseTarget = {
                                        targetNodeSort: this.data.refuseList[0].targetNodeSort,
                                        targetNodeId: this.data.refuseList[0].companyApproveWorkflowGroup.nodeId
                                    };
                                }
                            } else {
                                this.refuseTarget = {
                                    targetNodeSort: 0
                                };
                                this.dialogShow = true;
                            }
                        }
                    } else {
                        this.$toast.fail({
                            duration: 0,
                            forbidClick: true,
                            message: '数据错误'
                        });
                    }
                }
            },

            showPicker() {
                // if (/(BD-ANDROID)/i.test(navigator.userAgent) || /(BD-IOS)/i.test(navigator.userAgent)) {
                //     let extra = {
                //         refuseTarget: true
                //     };
                //     window.pickSingle(this.refuseList, this.refuseTarget ? {
                //         text: this.refuseTarget.label,
                //         value: this.refuseTarget.targetNodeSort
                //     } : '', extra);
                // } else {
                if (!this.picker) {
                    this.picker = this.$createPicker({
                        data: [this.refuseList],
                        onSelect: (selectedVal, selectedIndex, selectedText) => {
                            this.refuseTarget = {
                                label: selectedText[0],
                                targetNodeSort: selectedVal[0].nodeSort,
                                targetNodeId: selectedVal[0].nodeId
                            };
                        },
                        onCancel: () => {
                        }
                    });
                }
                this.picker.show();
                // }
            },

            //同意审批
            agree(content, condition, hrProperty, isForce, newRules) {
                if (this.data.temp.opinionRequired && !this.opinionRemind.trim()) {
                    this.$toast.fail({
                        duration: 1000,
                        forbidClick: true,
                        message: '请填写审批意见'
                    });
                    return;
                }
                this.$toast.loading({
                    duration: 0,
                    loadingType: 'spinner',
                    forbidClick: true
                });

                let param = {
                    id: this.$route.query.detailId,
                    nodeSort: this.data.currentNodeSort,
                    reason: this.opinionRemind,
                    content: JSON.stringify(content),
                    params: JSON.stringify(condition),
                    hrProperty: JSON.stringify(hrProperty),
                    showContent: this.data.showContent,
                    isForce: isForce,
                    newRules: newRules
                };
                this.$http.post('badu/eaa/agreeApproveWorkFlow_V2.do', param).then((response) => {
                    this.$toast.clear();
                    if (response.rspCode == 0) {
                        this.opinionRemind = this.data.temp.opinionRemind;
                        this.$toast.success({
                            duration: 1000,
                            forbidClick: true,
                            message: '同意成功'
                        });
                        window.refreshList = true;
                        setTimeout(() => {
                            if (window.history.length <= 2) {
                                // this.REPLACE({ name: 'approve' });
                                window.closeWindow();
                            } else {
                                this.GO(-2);
                            }
                        }, 1000);
                    } else {
                        this.$toast.fail({
                            duration: 1000,
                            forbidClick: true,
                            message: response.rspMsg
                        });
                    }
                }).catch((error) => {
                    console.log(error);
                    if (error.rspCode == 23) {
                        this.$toast.clear();
                        this.forceDialog = true;
                    } else if (error.rspCode == 24) {
                        console.log('24=====');
                        this.$toast.clear();
                        this.getTemplateData(error.rspMsg);
                    } else {
                        this.$toast.clear();
                        this.$toast.fail({
                            forbidClick: true,
                            message: error.rspMsg || '网络异常'
                        });
                    }
                });
            },

            //驳回审批
            refuse(condition, hrProperty) {
                console.log('refuse', this.refuseTarget);
                if (!this.refuseTarget) {
                    this.$toast.fail({
                        duration: 1000,
                        forbidClick: true,
                        message: '请选择驳回路线'
                    });
                    return;
                }
                if (this.data.temp.opinionRequired && !this.opinionRemind.trim()) {
                    this.$toast.fail({
                        duration: 1000,
                        forbidClick: true,
                        message: '请填写审批意见'
                    });
                    return;
                }
                let targetNodeSort = this.refuseTarget.targetNodeSort;
                if (targetNodeSort > 0) {
                    let targetNodeId = this.refuseTarget.targetNodeId;
                    for (let i = 0; i < this.nodes.length; i++) {
                        if (this.nodes[i].shape == 'NODE_CREATE_USER' && targetNodeId == this.nodes[i].id) {
                            targetNodeSort = 0; //驳回到发起人
                        }
                    }
                }
                this.$toast.loading({
                    duration: 0,
                    loadingType: 'spinner',
                    forbidClick: true
                });
                let param = {
                    id: this.$route.query.detailId,
                    nodeSort: this.data.currentNodeSort,
                    targetNodeSort: targetNodeSort,
                    reason: this.opinionRemind,
                    params: JSON.stringify(condition),
                    hrProperty: JSON.stringify(hrProperty)
                };
                this.$http.post('badu/eaa/refuseApproveWorkFlow_V2.do', param).then((response) => {
                    this.$toast.clear();
                    if (response.rspCode == 0) {
                        this.opinionRemind = this.data.temp.opinionRemind;
                        this.$toast.success({
                            duration: 1000,
                            forbidClick: true,
                            message: '驳回成功'
                        });
                        window.refreshList = true;
                        setTimeout(() => {
                            if (window.history.length <= 2) {
                                // this.REPLACE({ name: 'approve' });
                                window.closeWindow();
                            } else {
                                this.GO(-2);
                            }
                        }, 1000);
                    } else {
                        this.$toast.fail({
                            duration: 1000,
                            forbidClick: true,
                            message: response.rspMsg
                        });
                    }
                }).catch((error) => {
                    console.log(error);
                    this.$toast.clear();
                    this.$toast.fail({
                        forbidClick: true,
                        message: error.rspMsg || '网络异常'
                    });
                });
            },

            beforeClose(action, done) {
                if (action === 'confirm') {
                    done();
                    this.commit(true);
                } else {
                    done();
                }
            },

            commit(isForce = false, newRules) {
                console.log('commit');
                let emptyResult = this.checkEmpty(this.itemsList);
                if (!emptyResult.success) {
                    this.showEmptyTip(emptyResult.label, emptyResult.extra);
                    return;
                }


                let content = this.loopCompnents(this.itemsList);
                this.result = {
                    ...this.result,
                    ...content
                };

                let commitData = this.loopCondition(this.data.temp.conditions, this.result);
                console.log('commitData', commitData);

                if (this.$route.query.isAgree) {
                    this.agree(this.result, commitData.condition, commitData.hrProperty, isForce, newRules);
                } else {
                    this.refuse(commitData.condition, commitData.hrProperty);
                }
            },


            getTemplateData(nodeId) {
                this.$toast.loading({
                    duration: 0,
                    loadingType: 'spinner',
                    forbidClick: true
                });
                let param = {
                    id: this.data.approveId
                };
                this.$http.post('badu/eaa/queryCompanyApproveFormAndProcessSetting.do', param).then((response) => {
                    this.$toast.clear();
                    let newRules = this.getRules(response.data.process, nodeId);
                    let oldRules = this.getRules(this.data.temp.process, nodeId);
                    console.log(newRules, oldRules);
                    if (newRules && newRules != oldRules) {
                        Dialog.confirm({
                            title: '提示',
                            message: '原审批人已失效，发现新的审批人，是否尝试提交到新的审批人审核？'
                        }).then(() => {
                            // on confirm
                            this.commit(false, newRules);
                        }).catch(() => {
                            // on cancel
                        });
                    } else {
                        this.$toast.fail({
                            duration: 1000,
                            forbidClick: true,
                            message: '请联系管理员重新设置审批人'
                        });
                    }
                }).catch((error) => {
                    console.log('getData error', error);
                    this.$toast.clear();
                });
            },

            getRules(processStr, nodeId) {
                if (!processStr) {
                    return null;
                }
                let process = JSON.parse(processStr);
                if (process.nodes && process.nodes.length) {
                    for (let i = 0; i < process.nodes.length; i++) {
                        let nodeItem = process.nodes[i];
                        if (nodeItem.id == nodeId) {
                            return JSON.stringify(nodeItem);
                        }
                    }
                }
                return null;
            },

            addCommonRequest(content) {
                this.$toast.loading({
                    duration: 0,
                    loadingType: 'spinner',
                    forbidClick: true
                });
                let param = {
                    content: content
                };
                this.$http.post('badu/eaa/addApproveCommonLanguage.do', param).then(() => {
                    this.$toast.clear();
                    this.commonAddDialog = false;
                    this.addCommonStr = '';
                    this.commonLoaded = false;
                    this.showCommonClick();
                }).catch(() => {
                    this.$toast.fail({
                        duration: 1000,
                        forbidClick: true,
                        message: '添加失败'
                    });
                });
            },

            deleteCommonRequest(id, index) {
                this.$toast.loading({
                    duration: 0,
                    loadingType: 'spinner',
                    forbidClick: true
                });
                let param = {
                    id: id
                };
                this.$http.post('badu/eaa/deleteApproveCommonLanguage.do', param).then(() => {
                    this.$toast.clear();
                    this.commonLoaded = false;
                    this.commonList.splice(index, 1);
                    if (this.commonList.length == 0) {
                        this.commonDelete = false;
                    }
                }).catch(() => {
                    this.$toast.fail({
                        duration: 1000,
                        forbidClick: true,
                        message: '删除失败'
                    });
                });
            },

            queryCommonRequest() {
                this.commonLoading = true;
                let param = {};
                this.$http.post('badu/eaa/queryApproveCommonLanguage.do', param).then((response) => {
                    this.commonLoading = false;
                    this.commonLoaded = true;
                    this.commonList.splice(0, this.commonList.length, ...response.data);
                }).catch(() => {
                    this.commonLoading = false;
                });
            },

            addCommonClick() {
                this.addCommonRequest(this.addCommonStr);
            },

            showCommonClick() {
                if (!this.commonLoaded && !this.commonLoading) {
                    this.queryCommonRequest();
                }
                this.commonDialog = true;
            },

            onAutoComplete(arg, cmptList) {
                console.log('onAutoComplete', arg, cmptList);
                let result = arg[0];
                let modelId = arg[1];
                cmptList.forEach(function (cmpt) {
                    if (cmpt.autoWrite && cmpt.autoWrite.modelId == modelId) {
                        cmpt.value = result[cmpt.autoWrite.key] || '';
                    }
                });
            }
        }
    };
</script>

<style lang="scss"
       scoped>
    @import '../../assets/scss/approve.scss';
    @import '../../assets/scss/approve-create.scss';
</style>
